<template>
<div>
  <EOL :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0"></EOL>
</div>
</template>

<script>
import EOL from "../../components/EOL-ColumnAlpha";

import { Chart } from "highcharts-vue";

export default {
  name: "dashboard",
  components: {
    EOL,
    highcharts: Chart
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
